import { apiService } from "../services/api.service";
import { authenticationService } from "../services/authentication.service";

export const balikArtikleController = {
    getForCreateEdit,
    getArtikelByCiarovyKod,
    TEMP_GetArtikel,
    VratenieTovaruMimoVln,
    SaveBalik,
    ValidateDeletedBalik,
    DeleteBalik
};

function getForCreateEdit(idBalik) {
    return apiService.fetchApiRequest("api/BalikArtikle/GetForCreateEdit?idBalik=" + idBalik);
}

function getArtikelByCiarovyKod(balik, ciarovyKod) {
    const currentUser = authenticationService.currentUserValue;

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify({ balik, ciarovyKod })
    };
    return apiService.fetchApiRequest("api/BalikArtikle/GetArtikelByCiarovyKod", true, requestOptions);
}

function TEMP_GetArtikel(balik) {
    const currentUser = authenticationService.currentUserValue;

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify({ balik })
    };
    return apiService.fetchApiRequest("api/BalikArtikle/TEMP_GetArtikel", true, requestOptions);
}

function VratenieTovaruMimoVln(balik) {
    const currentUser = authenticationService.currentUserValue;

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify({ balik })
    };
    return apiService.fetchApiRequest("api/BalikArtikle/VratenieTovaruMimoVln", true, requestOptions);
}

function SaveBalik(balik) {
    const currentUser = authenticationService.currentUserValue;
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify({ balik })
    };
    return apiService.fetchApiRequest("api/BalikArtikle/Save", false, requestOptions);
}

function ValidateDeletedBalik(idBalik) {
    const currentUser = authenticationService.currentUserValue;
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify({ idBalik })
    };
    return apiService.fetchApiRequest("api/BalikArtikle/ValidateDeletedBalik", false, requestOptions);
}

function DeleteBalik(idBalik) {
    const currentUser = authenticationService.currentUserValue;
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify({ idBalik })
    };
    return apiService.fetchApiRequest("api/BalikArtikle/DeleteBalik", false, requestOptions);
}



// WEBPACK FOOTER //
// ./src/controllers/balikartikle.controller.js